/* Joi: issue countdown — ONE source of truth (theme settings via #joi-config).
   Renders inside every [data-joi-countdown] wrapper: ticker, home band, drop
   lede, PDP scarcity quote, sticky bar, empty cart. Zero-padded "DD d HH h",
   refreshes every 30 s, floors at zero, timezone-safe via the configured UTC
   offset (Asia/Dubai +04:00 — no DST). */

const config = JSON.parse(document.getElementById('joi-config')?.textContent || '{}');

const ARABIC_DIGITS = ['٠', '١', '٢', '٣', '٤', '٥', '٦', '٧', '٨', '٩'];

function localiseDigits(str) {
  /* Joi: Arabic-Indic countdown digits are opt-in (theme setting), per the
     approved AR design note — Western digits by default. */
  if (!(config.isRtl && config.arabicDigits)) return str;
  return String(str).replace(/\d/g, (d) => ARABIC_DIGITS[+d]);
}

function targetMs() {
  const raw = config.closeDate || '';
  if (!raw) return NaN;
  const iso = raw.includes('T') ? raw : `${raw}T23:59:59`;
  return new Date(`${iso}${config.utcOffset || '+04:00'}`).getTime();
}

function render() {
  const end = targetMs();
  if (Number.isNaN(end)) return;
  const ms = Math.max(0, end - Date.now());
  const closed = ms === 0;
  const pad = (n) => String(n).padStart(2, '0');
  const days = localiseDigits(pad(Math.floor(ms / 864e5)));
  const hours = localiseDigits(pad(Math.floor((ms % 864e5) / 36e5)));

  document.querySelectorAll('[data-joi-countdown]').forEach((wrap) => {
    const live = wrap.querySelector('[data-cd-live]');
    const closedLine = wrap.querySelector('[data-cd-closed]');
    if (closed) {
      if (config.countdownAtZero === 'hide') {
        wrap.hidden = true;
        return;
      }
      if (live) live.hidden = true;
      if (closedLine) closedLine.hidden = false;
      return;
    }
    wrap.hidden = false;
    if (live) live.hidden = false;
    if (closedLine) closedLine.hidden = true;
    wrap.querySelectorAll('[data-cd="days"]').forEach((el) => { el.textContent = days; });
    wrap.querySelectorAll('[data-cd="hours"]').forEach((el) => { el.textContent = hours; });
  });
}

if (config.countdownEnabled) {
  render();
  setInterval(render, 30000);
  /* Joi: sections re-rendered by the theme editor or cart AJAX need a fresh pass */
  document.addEventListener('shopify:section:load', render);
  document.addEventListener('joi:rerendered', render);
} else {
  document.querySelectorAll('[data-joi-countdown]').forEach((w) => { w.hidden = true; });
}
